import * as React from "react";

import { useTestPageObject } from "../../../../Services/TestPageObjects/PageObjectExposure";

import { Root } from "./Counter.styles";
import { CounterTestPageObject } from "./CounterTestPageObject";

export interface CounterProps {
    count: string | number;
    color?: string;
    backgroundColor?: string;
}

export const Counter = ({ count, color, backgroundColor }: CounterProps) => {
    useTestPageObject(() => CounterTestPageObject(count), [count]);
    return (
        <Root color={color} backgroundColor={backgroundColor}>
            {count}
        </Root>
    );
};
